export default {
  // 可能是通用的
  Monthly: '月費方案',
  Quarterly: '季費方案',
  Annually: '年費方案',
  Feature_List: '功能簡介',
  Unlimited: '無限制',
  Subscrible: '訂閱',
  day: '天',
  week: '週',
  month: '月',
  Download: '下載',
  Preso_Decks: '組簡報套組',
  count: '次',

  // 独有
  // subscribe_private:{}
  AI_Chat: 'AI 模型',
  More_Perks_Included: '更多尊享服務',
  Upload_PDF: '上傳PDF檔案',
  Questions: '問題咨詢',
  AI_PPT_GenDownload: 'AI PPT生成',
  Image_Analysis: '圖片分析',
  File_Analysis: '檔案分析',
  AI_Voice_Conversation: 'AI語音對話',
  Priority_Support: '優先支援',
  Early_Aecess_to_New_Features: '拾先體驗新功能',
  subscribe_c: {
    Generate: '圖片生成'
  }
}
